// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__28-jC","file":"styles_file__U1fiU"};